
import { IYoelloTheme } from "../../yoello-lib/modules/themes/IYoelloTheme";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from "@material-ui/core/styles/withStyles";


function setItemFontStyles(fontFamily: string,
  fontStyle: string,
  fontWeight: any,
  fontSize: string,
  lineHeight: string,
  color: string): CSSProperties {
  return {
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    fontSize: fontSize,
    lineHeight: lineHeight,
    color: color,
  }
}
export const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    submitButton: {
      marginRight: "auto",
    },
    Container: {
      padding: "2rem",
      "& form": {
        "& >div": {
          display: "flex",
          justifyContent: "left",
          flexDirection: "column",
          alignItems: "inherit",
          "& >div:not(:first-child)": {
            maxWidth: "30rem"
          }
        },
        "& button": {
          maxWidth: "20rem",
          "& >span:first-child": {
            position: "relative",
            "& >svg": {
              position: "absolute",
              left: "30px"
            }
          }
        },
        "& label": {
          ...setItemFontStyles("Open Sans", "normal", 600, "1.0625rem", "1.4375rem", "#616161")
        },
      },
    },
  }),
);